/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface IDateInput extends ng.IDirective {

    }

    interface IDateInputScope extends ng.IScope {
        format: string;
        timeZone: string;
    }

    class DateInput implements IDateInput {
        static directiveId: string = "dateInput";
        restrict: string = "A";
        require: any = "ngModel";
        
        link = (scope: IDateInputScope, element, attrs, ngModelCtrl: ng.INgModelController) => {
            ngModelCtrl.$formatters.unshift((modelValue) => {
                if (modelValue) {
                    return moment(modelValue).format(attrs.dateInput);
                }
            });

            ngModelCtrl.$parsers.unshift((viewValue) => {
                if (viewValue) {
                    var dateStringValue = moment.utc(viewValue, attrs.dateInput, true);

                    if (dateStringValue.isValid()) {
                        ngModelCtrl.$setValidity("date", true);
                        if (attrs.min) {
                            var minValue = moment(attrs.min);
                            if (dateStringValue.diff(minValue) > -1) {
                                ngModelCtrl.$setValidity("minDate", true);
                               
                            } else {
                                ngModelCtrl.$setValidity("minDate", false);
                            }
                        }

                        if (attrs.max) {
                            var maxValue = moment(attrs.max);
                            if (dateStringValue.diff(maxValue) < 1) {
                                ngModelCtrl.$setValidity("maxDate", true);

                            } else {
                                ngModelCtrl.$setValidity("maxDate", false);
                            }
                        }

                        return dateStringValue.startOf("day").toDate();
                    } else {
                        ngModelCtrl.$setValidity("date", false);
                    }

                    
                } else {
                    return null;
                }
            });

        };
    }

    angular.module("app").directive(DateInput.directiveId, [() =>
        new DateInput()
    ]);

}